import React from 'react';
import { observable, action } from 'mobx';
import { observer, inject } from 'mobx-react';
import { Row, Col, Tabs, Table, Icon, Button, Popconfirm, Input } from 'antd';
const TabPane = Tabs.TabPane;
import styles from './Content.less';

const EditableCell = ({ editable, value, onChange }) => (
  <div>
    {editable ? (
      <Input
        style={{ margin: '-5px 0' }}
        value={value}
        onChange={e => onChange(e.target.value)}
      />
    ) : (
      value
    )}
  </div>
);

@observer
class TabContent extends React.Component {
  @observable
  tableData = this.props.data
    ? Object.keys(JSON.parse(this.props.data)).map((keyItem, index) => {
        return {
          lable: keyItem,
          value: JSON.parse(this.props.data)[keyItem],
          key: index
        };
      })
    : [];
  @observable cacheData = [...this.tableData].map(item => ({ ...item }));

  @observable
  columns = [
    {
      title: 'Key',
      dataIndex: 'lable',
      width: '35%',
      render: (text, record) => this.renderColumns(text, record, 'lable')
    },
    {
      title: 'Value',
      dataIndex: 'value',
      width: '35%',
      render: (text, record) => this.renderColumns(text, record, 'value')
    }
  ];
  componentDidMount() {
    if (!this.props.disabled) {
      this.columns.push({
        title: '操作',
        dataIndex: 'action',
        width: '30%',
        render: (text, record) => {
          const { editable } = record;
          return (
            <div className={styles.contentBtnContainer}>
              {editable ? (
                <Button
                  className={styles.BtnItem}
                  onClick={() => this.save(record.key)}
                >
                  保存
                </Button>
              ) : (
                <Button
                  className={styles.BtnItem}
                  onClick={() => this.edit(record.key)}
                >
                  编辑
                </Button>
              )}
              <Button
                onClick={() => this.delete(record.key)}
                className={styles.BtnItem}
              >
                删除
              </Button>
            </div>
          );
        }
      });
      this.props.changeTableData([...this.tableData], this.props.tabKey);
    }
  }

  @action
  handleChange(value, key, column) {
    const newData = [...this.tableData];
    const target = newData.filter(item => key === item.key)[0];
    if (target) {
      target[column] = value;
      this.tableData = newData;
      this.props.changeTableData([...this.tableData], this.props.tabKey);
    }
  }

  @action
  edit(key) {
    const newData = [...this.tableData];
    const target = newData.filter(item => key === item.key)[0];
    if (target) {
      target.editable = true;
      this.tableData = newData;
      this.props.changeTableData([...this.tableData], this.props.tabKey);
    }
  }

  @action
  save(key) {
    const newData = [...this.tableData];
    const target = newData.filter(item => key === item.key)[0];
    if (target) {
      delete target.editable;
      this.tableData = newData;
      this.cacheData = newData.map(item => ({ ...item }));
      this.props.changeTableData([...this.tableData], this.props.tabKey);
    }
  }

  @action
  delete(key) {
    const newData = [...this.tableData];
    const target = newData.filter(item => key !== item.key);
    if (target) {
      this.tableData = target;
      this.props.changeTableData([...this.tableData], this.props.tabKey);
    }
  }

  @action.bound
  addTableItem() {
    this.tableData.push({
      lable: 'Key',
      value: 'value',
      key: [...this.tableData].length
    });
    this.props.changeTableData([...this.tableData], this.props.tabKey);
  }

  @action
  renderColumns(text, record, column) {
    return (
      <EditableCell
        editable={record.editable}
        value={text}
        onChange={value => this.handleChange(value, record.key, column)}
      />
    );
  }

  render() {
    const { data, disabled, tabKey } = this.props;
    return (
      <div>
        <Table
          pagination={false}
          columns={[...this.columns]}
          dataSource={[...this.tableData]}
          scroll={{ y: 100 }}
        />
        {!disabled && <Button onClick={this.addTableItem}>添加键值对</Button>}
      </div>
    );
  }
}

@observer
class Content extends React.Component {
  @observable
  tabsNameArr = this.props.data ? Object.keys(this.props.data.content) : [];
  @observable
  panes = [...this.tabsNameArr].map((item, index) => {
    return {
      title: item,
      content: this.props.data.content[item],
      key: index + ''
    };
  });
  @observable activeKey = this.panes.length ? [...this.panes][0].key : null;
  @observable inputValue = '';
  @observable tableData = [];

  componentDidMount() {
    this.props.changeContent &&
      this.props.changeContent(this.panes, this.tableData);
  }

  @action.bound
  onEdit(targetKey, action) {
    this[action](targetKey);
  }

  @action.bound
  onChange(activeKey) {
    this.activeKey = activeKey;
  }

  @action.bound
  remove(targetKey) {
    let activeKey = this.activeKey;
    let lastIndex;
    [...this.panes].forEach((pane, i) => {
      if (pane.key === targetKey) {
        lastIndex = i - 1;
      }
    });
    const panes = [...this.panes].filter(pane => pane.key !== targetKey);
    if (lastIndex >= 0 && activeKey === targetKey) {
      activeKey = panes[lastIndex].key;
    }
    this.panes = panes;
    this.activeKey = activeKey;
    this.props.changeContent(this.panes, this.tableData);
  }

  @action.bound
  changeInputValue(e) {
    this.inputValue = e.target.value;
  }

  @action.bound
  add() {
    const panes = [...this.panes];
    const activeKey = panes.length + '';
    panes.push({
      title: this.inputValue,
      content: JSON.stringify({ key: 'value' }),
      key: activeKey
    });
    this.panes = panes;
    this.activeKey = activeKey;
    this.inputValue = '';
    this.props.changeContent(this.panes, this.tableData);
  }

  @action.bound
  changeTableData(val, tabKey) {
    this.tableData = val;
    let tableContent = [...val].reduce(
      (prev, cur) => ({ ...prev, [cur.lable]: cur.value }),
      {}
    );
    let panes = [...this.panes];
    panes.forEach(pane => {
      if (pane.key === tabKey) {
        pane.content = JSON.stringify(tableContent);
      }
    });
    this.panes = panes;
    this.props.changeContent(this.panes, this.tableData);
  }

  render() {
    const { data, labelCol, wrapperCol, disabled } = this.props;
    return (
      <Row className={styles.deviceConfigContentContainer}>
        <Col
          span={labelCol || 2}
          className={!disabled ? styles.labelConatiner : ''}
        >
          配置内容 : &nbsp;&nbsp;
        </Col>
        <Col span={wrapperCol || 20} className={styles.configtabsContainer}>
          <Tabs
            tabPosition="left"
            hideAdd
            onChange={this.onChange}
            activeKey={this.activeKey}
            type="editable-card"
            onEdit={this.onEdit}
          >
            {[...this.panes].map(pane => (
              <TabPane tab={pane.title} key={pane.key} closable={!disabled}>
                <TabContent
                  data={pane.content}
                  disabled={disabled}
                  tabKey={pane.key}
                  changeTableData={this.changeTableData}
                />
              </TabPane>
            ))}
          </Tabs>
          <Popconfirm
            title={
              <div>
                <span>请输入前缀名称</span>
                <Input
                  ref={node => (this.nameInput = node)}
                  onChange={this.changeInputValue}
                  value={this.inputValue}
                  placeholder="请输入前缀名称"
                />
              </div>
            }
            onConfirm={this.add}
            okText="确认"
            cancelText="取消"
          >
            {!disabled && <Button className={styles.addBtn}>添加前缀</Button>}
          </Popconfirm>
        </Col>
      </Row>
    );
  }
}

export default Content;



// WEBPACK FOOTER //
// ./src/components/DeviceConfig/Content.js